module.exports = __webpack_public_path__ + "static/media/hockey-puck.d9851030.svg";